import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Icon, InputGroup } from '@maui/elements'
import { maApiFetch } from '../../../../../api/apis'
import { notifyError } from '../../../../../utilities/downloadFile'

const NoButton = ({ children, submitting }) => (
  <Button disabled={submitting} type='submit' padding='0' backgroundColor='transparent' border='none'>
    { children }
  </Button>
)

NoButton.propTypes = {
  children: PropTypes.node.isRequired,
  submitting: PropTypes.bool,
}

export default function AddComment({ caseId, updateComments }) {
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    setSubmitting(true)
    const formData = {
      comment: {
        case_id: caseId,
        body: e.target.elements.comment.value,
      }
    }
    const formBody = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    }
    maApiFetch('/eod/comments', formBody)
      .then(res => {
        setSubmitting(false)
        updateComments(res)
        e.target.reset()
      })
      .catch(error => {
        notifyError('Error', 'Unable to save your comment. Please try again.')
        throw new Error(error)
      })
  }

  return (
    <Box
      padding='spaceGapMedium'
      margin='-16px'
      backgroundColor='colorBackgroundOverlay'
    >
      <form onSubmit={handleSubmit} width='100%'>
        <InputGroup
          width='100%'
          disabled={submitting}
          {...(submitting && { color: 'colorTextDisabled' })}
          inputProps={{
            name: 'comment',
            placeholder: 'Add a comment',
            disabled: submitting,
            color: submitting ? 'colorTextDisabled' : 'inherit'
          }}
          slotRight={
            <NoButton>
              <Icon
                color='colorActionSecondary'
                svg={{
                  viewBox: '0 0 14 13',
                  path: 'M11.876 0.59375C12.04 0.5 12.2275 0.476562 12.415 0.523438C12.6025 0.570312 12.7432 0.6875 12.8604 0.828125C12.9775 0.992188 13.0244 1.17969 13.001 1.36719L11.501 11.1406C11.4541 11.375 11.3135 11.5625 11.1025 11.6797C10.8916 11.8203 10.6807 11.8203 10.4697 11.7266L7.49316 10.4844L6.08691 12.2188C5.94629 12.4062 5.75879 12.5 5.54785 12.5C5.31348 12.5234 5.12598 12.4531 4.98535 12.3125C4.82129 12.1719 4.75098 11.9844 4.75098 11.75V9.35938L1.46973 8C1.28223 7.92969 1.1416 7.8125 1.07129 7.625C0.977539 7.46094 0.977539 7.27344 1.02441 7.08594C1.07129 6.89844 1.18848 6.75781 1.37598 6.66406L11.876 0.59375ZM5.50098 11.75L6.79004 10.2031L5.50098 9.66406V11.75ZM10.751 11.0234L12.251 1.25L1.75098 7.29688L4.42285 8.39844L10.3994 3.3125C10.4463 3.26562 10.5166 3.26562 10.5869 3.3125C10.6338 3.38281 10.6338 3.45312 10.5869 3.5L5.92285 9.03125L10.751 11.0234Z'
                }}
              />
            </NoButton>
          }
        />
        { submitting && <Box variant='heading5' marginTop='-25px' marginBottom='25px' textAlign='center'>Adding comment...</Box> }
      </form>
    </Box>
  )
}

AddComment.propTypes = {
  caseId: PropTypes.string.isRequired,
  updateComments: PropTypes.func.isRequired,
}
